import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Component/AppComponent/BreadCrumb/BreadCrumb";
import testLogo from "../../Assets/AppComponent/Logo/Home.svg";
import createUser from "../../Assets/AppComponent/Logo/createUser.svg";
import "../../StyleSheet/MainComponent/Role/CreateMail.scss";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import "../../StyleSheet/Page/CreateUser/CreateUserForm.scss";
import Select from "react-select";
import Header from "../../Component/AppComponent/Header/Header";
import profile_image from "../../Assets/AppComponent/Logo/profileIcon.svg";
import { setUserPostActions, SetUserPostUpdateResponse, setUserGetActions, usereditid, setUserPutActions, SetUserPutUpdateResponse } from "../../Redux/Slice";

function CreateUserForm() {
  const [data, setData] = useState({
    first_name: "",
    email: "",
    // last_name: "",
    // password: "",
    // profile_image: "",
    role: "",
    is_active: "",
  });
  const projectNameFeeder = ["admin", "employee"];
  const [projectSelected, setProjectSelected] = useState([]);

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const userDetails = useSelector((state) => state.users.UserData.data.email);
  const userpostres = useSelector((state) => state.UserPostData)
  const userputres = useSelector((state) => state.UserPutData)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const usereditiddata = useSelector((state) => state.SideBarActive.usereditid)

  const userdata = useSelector((state) => state.UserGetData)

  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: testLogo,
      title: "DASHBOARD",
    },
    {
      id: "2",
      href: "/createuser",
      source: createUser,
      title: "Create User",
    },
  ];


  const innerRightInputFields = [
    {
      label: "Name",
      id: "first_name",
      name: "first_name",
      value: data.first_name,
    },
    {
      label: "EMAIL ID",
      id: "email",
      name: "email",
      value: data.email,
    },
    usereditiddata == undefined || usereditiddata == ""
    && {
      label: "Password",
      id: "password",
      name: "password",
      value: data.password,
    }
  ].filter(Boolean);
  const innerLeftInputFields = [
    {
      label: "Last Name",
      id: "last_name",
      name: "last_name",
      value: data.last_name,
    },
  ];

  const [fieldErrors, setFieldErrors] = useState({
    first_name: "",
    email: "",
    last_name: "",
    password: "",
    profile_image: "",
    role: "",
    is_active: "",
  });

  useEffect(() => {
    //console.log(usereditiddata, "id")
    if (usereditiddata != undefined && usereditiddata != "") {
      dispatch(setUserGetActions({
        id: usereditiddata
      }))

    }
  }, [usereditiddata])


  useEffect(() => {
    if (userdata?.UserGet?.data?.length > 0 && usereditiddata != undefined && usereditiddata != "") {
      setData({
        first_name: userdata?.UserGet?.data[0]?.first_name,
        email: userdata?.UserGet?.data[0]?.email,
        role: userdata?.UserGet?.data[0]?.role,
        is_active: userdata?.UserGet?.data[0]?.is_active,
      })
    }
  }, [userdata])
  useEffect(() => {
    if (userpostres != null && Object.keys(userpostres?.UserPost).length > 0) {
      dispatch(SetUserPostUpdateResponse([]))
      window.location.href=("/createUser")
      // navigate("/createUser")
      dispatch(usereditid(""))
    }
  }, [userpostres]);

  useEffect(() => {
    //console.log(userputres, "adfhgaj")


    if (userputres != null && userputres?.UserPut?.first_name != undefined) {
      dispatch(SetUserPutUpdateResponse([]))
      navigate("/createUser")
      dispatch(usereditid(""))
    }
  }, [userputres]);

  const HandleChanges = (e) => {
    setFieldErrors((prev) => {
      return {
        ...prev,
        [e.target.name]: "",
      };
    });
    setData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        background: isFocused
          ? "rgba(242, 102, 57, 0.7)"
          : isDisabled
            ? "rgb(255,255,255)"
            : "transparent",
        color: isFocused ? "white" : "black",
        ":active": {
          backgroundColor: "rgba(242, 102, 57, 0.7)",
        },
      };
    },
  };
  const [imgsrc, setImgsrc] = useState("");
  const selectedImage = (e) => {
    //console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgsrc(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  // const handleSubmit = (e) => {
  //   //console.log("hello");
  //   e.preventDefault();
  //   const newFieldErrors = {};
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   Object.entries(data).forEach(([key, value]) => {
  //     if (key === "f_name") {
  //       if (value.length === 0) {
  //         newFieldErrors[key] = "First name required.";
  //       }
  //       return;
  //     }
  //     if (key === "last_name") {
  //       if (value.length === 0) {
  //         newFieldErrors[key] = "Last name required.";
  //       }
  //       return;
  //     }

  //     if (!value) {
  //       //console.log(key, value);
  //       newFieldErrors[key] = `
  //       ${key.charAt(0).toUpperCase() + key.slice(1)} is required.`;
  //       //console.log(newFieldErrors);
  //     } else if (key === "email" && !emailRegex.test(value)) {
  //       newFieldErrors[key] = "Invalid email format.";
  //     } else {
  //       newFieldErrors[key] = "";
  //     }
  //   });
  //   setFieldErrors(newFieldErrors);
  //   // Check if any field has an error
  //   const hasError = Object.values(newFieldErrors).some((error) => error);
  //   if (!hasError) {
  //     // Proceed with form submission or other action
  //     //console.log("Form submitted successfully!");
  //     // setData({ ...data, file_path: [treeFileSelected] });
  //     //console.log(data, "Form submitted successfully!");
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();


    // Proceed with form submission or other action


    if (usereditiddata != undefined && usereditiddata != "") {
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // const validationRules = {
      //   first_name: "First name required.",
      //   last_name: "Last name required.",
      //   email: "Invalid email format.",
      // };
      // const newFieldErrors = {};
      // for (const [key, value] of Object.entries(data)) {
      //   // if (key === "profile_image") {
      //   //   continue; // Skip validation for profile_image
      //   // }
      //   if (key === "first_name" || key === "last_name") {
      //     if (value.length === 0) {
      //       newFieldErrors[key] = validationRules[key];
      //     }
      //   } else {
      //     if (!value) {
      //       newFieldErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)
      //         } is required.`;
      //     } else if (key === "email" && !emailRegex.test(value)) {
      //       newFieldErrors[key] = validationRules[key];
      //     }
      //     // else if (key === "password" && !emailRegex.test(value)) {
      //     //   newFieldErrors[key] = validationRules[key];
      //     // }
      //     else {
      //       newFieldErrors[key] = "";
      //     }
      //   }
      // }
      // setFieldErrors(newFieldErrors);
      // // Check if any field has an error
      // const hasError = Object.values(newFieldErrors).some((error) => error);
      // if (hasError) {
      //   //console.log(userDetails, "kjalsjdkflasjldfjlajfs");
      //   return; // Exit early if there are errors
      // }
      //console.log("Form submitted successfully!");

      dispatch(setUserPutActions({
        id: usereditiddata,
        data: data
      }))

    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validationRules = {
        first_name: "First name required.",
        last_name: "Last name required.",
        email: "Invalid email format.",
        password:
          "Password must be 8+ characters with a special character and a number.",
      };
      const newFieldErrors = {};
      for (const [key, value] of Object.entries(data)) {
        // if (key === "profile_image") {
        //   continue; // Skip validation for profile_image
        // }
        if (key === "first_name" || key === "last_name") {
          if (value.length === 0) {
            newFieldErrors[key] = validationRules[key];
          }
        } else if (key === "password") {
          if (
            !value ||
            value.length < 8 ||
            !/[!@#$%^&*(),.?":{}|<>]/.test(value) ||
            !/\d/.test(value)
          ) {
            newFieldErrors[key] = validationRules[key];
          }
        } else {
          if (!value) {
            newFieldErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)
              } is required.`;
          } else if (key === "email" && !emailRegex.test(value)) {
            newFieldErrors[key] = validationRules[key];
          }
          // else if (key === "password" && !emailRegex.test(value)) {
          //   newFieldErrors[key] = validationRules[key];
          // }
          else {
            newFieldErrors[key] = "";
          }
        }
      }
      setFieldErrors(newFieldErrors);
      // Check if any field has an error
      const hasError = Object.values(newFieldErrors).some((error) => error);
      if (hasError) {
        //console.log(userDetails, "kjalsjdkflasjldfjlajfs");
        return; // Exit early if there are errors
      }
      dispatch(setUserPostActions(data))

    }

  };

  return (
    <div
      className={
        stateDisplay
          ? "outterContent createUserFormDiv"
          : "inner-Content createUserFormDiv"
      }
    >
      <Header breadCrumbsData={breadcrumbsData} heading={userdata?.UserGet?.data?.length > 0 && usereditiddata != undefined && usereditiddata != ""?"Edit User Form":"Create User Form"} />
      <div className="CreateFormModalBody">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          {/* <div className="rightForm">
            {data.profile_image.length === 0 ? (
              <>
                <input
                  type="file"
                  id="myFile"
                  name="filename"
                  accept="image/png, image/jpeg"
                  onChange={(e) => {
                    selectedImage(e);
                    setData({ ...data, profile_image: e.target.files[0] });
                    //console.log(e.target.files[0], "ljsdlfkajsdlfjslajdflajfj");
                  }}
                />
                <img
                  src={profile_image}
                  alt=""
                  height={"185px"}
                  width={"185px"}
                />
                <p>Upload a Profile Picture</p>
              </>
            ) : (
              <>
                <img src={imgsrc} alt="" height={"185px"} width={"185px"} />
                <p>Profile</p>
                <input
                  type="file"
                  id="myFile"
                  name="filename"
                  onChange={(e) => {
                    selectedImage(e);
                    //console.log(e.target.files[0], "ljsdlfkajsdlfjslajdflajfj");
                  }}
                />
              </>
            )}
          </div> */}
          <div className="leftForm">
            <div className="innerRight">
              {innerRightInputFields.map((field, index) => (
                <div key={index}>
                  <label htmlFor={field.id} className="form-label">
                    {field.label}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id={field.id}
                    autoComplete="off"
                    name={field.name}
                    value={field.value}
                    onChange={(e) => {
                      HandleChanges(e);
                    }}
                  />
                  {fieldErrors[field.name] ? (
                    <div
                      className="error"
                      style={{
                        color: "#626262",
                        height: "20px",
                        padding: "5px",
                      }}
                    >
                      {fieldErrors[field.name]}
                      <span style={{ color: "red" }}>*</span>
                    </div>
                  ) : (
                    <div
                      className="error"
                      style={{
                        // color: "red",
                        height: "20px",
                        width: "100%",
                      }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
            <div className="innerLeft">
              {/* {innerLeftInputFields.map((field, index) => (
                <div key={index}>
                  <label htmlFor={field.id} className="form-label">
                    {field.label}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id={field.id}
                    autoComplete="off"
                    name={field.name}
                    value={field.value}
                    onChange={(e) => {
                      HandleChanges(e);
                    }}
                  />
                  {fieldErrors[field.name] ? (
                    <div
                      className="error"
                      style={{
                        color: "#626262",
                        height: "20px",
                        padding: "5px",
                      }}
                    >
                      {fieldErrors[field.name]}
                      <span style={{ color: "red" }}>*</span>
                    </div>
                  ) : (
                    <div
                      className="error"
                      style={{
                        // color: "red",
                        height: "20px",
                        width: "100%",
                      }}
                    ></div>
                  )}
                </div>
              ))} */}

              <label htmlFor="project" className="form-label">
                {" "}
                Role
                <span style={{ color: "red" }}>*</span>
              </label>
              <div>
                <Select
                  className="Selects"
                  styles={customStyles}
                  onChange={(e) => {
                    setFieldErrors((prev) => {
                      return {
                        ...prev,
                        role: "",
                      };
                    });
                    setProjectSelected([e.value]);
                    setData((prev) => {
                      return {
                        ...prev,
                        role: e.value,
                      };
                    });
                  }}
                  name="role"
                  options={projectNameFeeder?.map((branch) => ({
                    value: branch,
                    label: branch,
                  }))}
                  value={[{
                    value: data.role,
                    label: data.role,
                  }]}
                />
              </div>
              {fieldErrors.region ? (
                <div
                  className="error"
                  style={{
                    color: "#626262",
                    height: "20px",
                    padding: "5px",
                  }}
                >
                  {fieldErrors.region}
                  <span style={{ color: "red" }}>*</span>
                </div>
              ) : (
                <div
                  className="error"
                  style={{
                    // color: "red",
                    height: "20px",
                    width: "100%",
                  }}
                ></div>
              )}
              <label className="form-label">
                Profile Active
                <span style={{ color: "red" }}>*</span>
              </label>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={data.is_active}
                onChange={(e) => {
                  setData((prev) => {
                    return {
                      ...prev,
                      is_active: e.target.value,
                    };
                  });
                }}
              >
                <FormControlLabel value={true} control={<Radio />} label="Yes" />
                <FormControlLabel value={false} control={<Radio />} label="No" />
              </RadioGroup>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "30px",
                  marginTop: "30px",
                }}
              >
                <button
                  type="submit"
                  style={{
                    background:
                      "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
                  }}
                  className="custom-button"
                >
                  {userdata?.UserGet?.data?.length > 0 && usereditiddata != undefined && usereditiddata != ""?"Edit User":"Create User"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUserForm;
